import { HOME_CSW_RANKING } from 'shared/experiments/consts'
import { trackCswSlider } from 'shared/experiments/consts/trackCswSlider'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'

export default () => {
  const homeCswRanking = getExperimentOnClient(HOME_CSW_RANKING)

  if (homeCswRanking.isEnabled) {
    void activateExperiment(HOME_CSW_RANKING)
    trackCswSlider({ shouldTrackWithWidgetIds: true })
  }
}
